class CoupleCratePersonalize extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector('[data-cc-variant-input]');
    this.priceOut = this.querySelector('[data-cc-price-out]');
    this.comparePriceOut = this.querySelector('[data-cc-compare-price-out]');
    this.saleLabel = this.querySelector('[data-cc-sale-label]');
    this.colorsSelect = this.querySelector('[data-cc-colors-select]');
    this.colorSlots = [...this.querySelectorAll('[data-cc-color-slot]')];
    this.nameInputs = [...this.querySelectorAll('[data-cc-name]')];
    this.summary = this.querySelector('[data-cc-summary]');
    this.galleryMain = this.querySelector('[data-cc-gallery-main]');
    this.thumbs = [...this.querySelectorAll('[data-cc-thumb]')];

    this.colorsSelect?.addEventListener('change', () => this.#onColorsCountChange());
    this.colorSlots.forEach((slot) => {
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          this.#syncColorExclusion();
          this.#updateSummary();
        });
      });
    });
    this.nameInputs.forEach((input) => input.addEventListener('input', () => this.#onNameInput(input)));
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.#onThumbClick(thumb)));

    this.#onColorsCountChange();
    this.#updateSummary();
  }

  #onColorsCountChange() {
    if (!this.colorsSelect) return;
    const option = this.colorsSelect.selectedOptions[0];
    const variantId = option?.dataset.variantId;
    const price = option?.dataset.price;
    const comparePrice = option?.dataset.comparePrice;
    const onSale = option?.dataset.onSale === 'true';
    const count = Number(option?.dataset.count || 2);

    if (variantId && this.variantInput) this.variantInput.value = variantId;
    if (price && this.priceOut) this.priceOut.textContent = price;
    if (this.comparePriceOut) {
      this.comparePriceOut.textContent = comparePrice || '';
      this.comparePriceOut.hidden = !onSale;
    }
    if (this.saleLabel) this.saleLabel.hidden = !onSale;

    this.colorSlots.forEach((slot) => {
      const index = Number(slot.dataset.ccColorSlot);
      const active = index <= count;
      slot.hidden = !active;
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.disabled = !active;
        if (!active) radio.checked = false;
      });
    });

    this.#syncColorExclusion();
    this.#updateSummary();
  }

  #syncColorExclusion() {
    const visibleSlots = this.colorSlots.filter((slot) => !slot.hidden);
    const chosen = visibleSlots
      .map((slot) => slot.querySelector('input[type="radio"]:checked'))
      .filter(Boolean)
      .map((input) => input.value);

    visibleSlots.forEach((slot) => {
      const own = slot.querySelector('input[type="radio"]:checked')?.value;
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const takenByOther = chosen.includes(radio.value) && radio.value !== own;
        radio.closest('[data-cc-swatch]')?.classList.toggle('is-taken', takenByOther);
      });
    });
  }

  #onNameInput(input) {
    const counter = input.parentElement?.querySelector('[data-cc-char-count]');
    if (counter) {
      const max = input.maxLength > 0 ? input.maxLength : null;
      counter.textContent = max ? `${input.value.length} / ${max}` : `${input.value.length}`;
    }
    this.#updateSummary();
  }

  #onThumbClick(thumb) {
    if (!this.galleryMain) return;
    this.galleryMain.src = thumb.dataset.ccThumb;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
  }

  #updateSummary() {
    if (!this.summary) return;
    const lines = [];

    this.nameInputs.forEach((input) => {
      const label = input.dataset.ccName;
      lines.push(`${label}: ${input.value.trim() || '—'}`);
    });

    this.colorSlots
      .filter((slot) => !slot.hidden)
      .forEach((slot) => {
        const label = slot.dataset.ccColorLabel;
        const checked = slot.querySelector('input[type="radio"]:checked');
        lines.push(`${label}: ${checked ? checked.dataset.colorName : '—'}`);
      });

    this.summary.innerHTML = lines.map((line) => `<span>${line}</span>`).join('');
  }
}

if (!customElements.get('couple-crate-personalize')) {
  customElements.define('couple-crate-personalize', CoupleCratePersonalize);
}
